import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import { getAtkomstSuperUsers } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { normalizeFixaTeamStoreId } from "@coworker/apprestructured/src/shared/types/store";

export interface AtkomstSuperUser {
  email: string;
  uid?: string;
  fullName: string;
}

export interface AtkomstSuperUsersResponse {
  storeSuperUsers: AtkomstSuperUser[];
  countrySuperUsers: AtkomstSuperUser[];
}

export function useAtkomstSuperUsers(
  storeId?: string,
  options?: { enabled?: boolean }
) {
  const defaultStoreId = useStoreId();
  const effectiveStoreId = storeId || defaultStoreId;
  // Normalize composite ids (e.g. "012#fixa-team", "481$fixa-team" → base store id)
  const normalizedStoreId = effectiveStoreId
    ? normalizeFixaTeamStoreId(effectiveStoreId)
    : undefined;
  const isEnabled = (options?.enabled ?? true) && !!normalizedStoreId;

  return useQuery<AtkomstSuperUsersResponse>({
    enabled: isEnabled,
    queryKey: ["atkomst", "super-users", normalizedStoreId],
    queryFn: async () => await getAtkomstSuperUsers(normalizedStoreId!),
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
  });
}
